import React from 'react'

const FilmIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="filmGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(200, 140, 255, 1)" />
          <stop offset="100%" stopColor="rgba(160, 100, 220, 1)" />
        </linearGradient>
        <filter id="filmGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Film strip */}
      <rect 
        x="3" 
        y="3" 
        width="18" 
        height="18" 
        rx="2"
        stroke="url(#filmGradient)"
        strokeWidth="2"
        fill="none"
        filter="url(#filmGlow)"
      />
      
      {/* Film holes - left */}
      <rect x="4" y="6" width="2" height="2" fill="url(#filmGradient)"/>
      <rect x="4" y="11" width="2" height="2" fill="url(#filmGradient)"/>
      <rect x="4" y="16" width="2" height="2" fill="url(#filmGradient)"/>
      
      {/* Film holes - right */}
      <rect x="18" y="6" width="2" height="2" fill="url(#filmGradient)"/>
      <rect x="18" y="11" width="2" height="2" fill="url(#filmGradient)"/>
      <rect x="18" y="16" width="2" height="2" fill="url(#filmGradient)"/>
      
      {/* Play triangle */}
      <path 
        d="M10 8l6 4-6 4V8z"
        fill="url(#filmGradient)"
      />
    </svg>
  )
}

export default FilmIcon
